import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Store} from '@ngxs/store';
import {ActivatedRoute, Router, UrlSerializer} from '@angular/router';
import {AuthState} from '../../state/auth.state';
import {CryptoService} from '../../services/crypto.service';
import {Address} from '../../models/accounts/address.model';
import {PaymentProviderConfiguration} from '../../models/payments/paymentProviderConfiguration.model';
import {PosService} from '../../services/pos.service';
import {OrganizationService} from '../../services/organization.service';
import Organization from '../../models/organization/organization.model';
import {Auth} from "../../actions/auth.actions";
import Logout = Auth.Logout;

@Component({
  standalone: false,
  selector: 'app-pay-invoice',
  templateUrl: './pay-invoice.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pay-invoice.component.scss']
})
export class PayInvoiceComponent implements OnInit {

  public organizationHandle: string;
  public organizationId: string;
  public id: string;
  public loadingIndicator: boolean;
  public invoice: any;

  public testProviderConfig: PaymentProviderConfiguration = {
    id: '',
    clientId: '',
    provider: 'STRIPE',
    merchantCode: '',
    clientSecret: '',
    enabled: true
  };


  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private router: Router,
    private cryptoService: CryptoService,
    private serializer: UrlSerializer,
    private posService: PosService,
    private organizationService: OrganizationService
  ) {
  }

  ngOnInit(): void {
    this.loadingIndicator = true;
    this.route.queryParams.subscribe(params => {
      const organizationHandle: string = params.org;
      const authenticated = this.store.selectSnapshot(AuthState.isAuthenticated);
      this.organizationService.getOrganization(organizationHandle, authenticated).subscribe((org: Organization) => {
        const encryptedOrgAndId: string = params.eoid;
        const decrypted = '?' + this.cryptoService.decryptUsingAES256(org, encryptedOrgAndId);
        const urlTree = this.serializer.parse(decrypted);
        this.id = urlTree.queryParams.id;
        this.organizationHandle = urlTree.queryParams.organizationHandle;
        this.organizationId = urlTree.queryParams.organizationId;
        this.init();
      });
    });
  }

  init(): void {
    this.loadingIndicator = true;
    this.store.selectOnce(AuthState.isAuthenticated).subscribe(async (isAuthenticated) => {
      if (isAuthenticated) {
        this.store.dispatch(new Logout()).subscribe(() => {
          this.refresh();
        });
      } else {
        this.posService.getFullInvoice(this.organizationHandle, this.id).subscribe((res) => {
          this.invoice = res;
          this.loadingIndicator = false;
        });
      }
    });
  }

  refresh(): void {
    location.reload();
  }

  getBillingAddress(): Address {
    return this.invoice.debtor.addresses.find((address: Address) => address.type === 'BILLING');
  }
}
